/* This file was generated automatically. Do not edit manually. */

export enum SmsUsaRegistrationJobPosition {
    Director = 'Director',
    Gm = 'Gm',
    Vp = 'Vp',
    Ceo = 'Ceo',
    Cfo = 'Cfo',
    GeneralCounsel = 'GeneralCounsel',
    Other = 'Other',
}
